export const getBankStatementList = state => {
    return state.list
}


// WEBPACK FOOTER //
// ./src/store/modules/bankStatement/getters.js